import React, { useContext, useEffect, useState } from "react";
import "./style.css";
import logo from "../../../Assets/Images/Logo.png";
import logoDark from "../../../Assets/icons/Sidebaricon/Logo Dark.svg";
import { useNavigate, useParams } from "react-router-dom";
import back from "../../../Assets/icons/move-right.svg";
import backDark from "../../../Assets/icons/move-right-dark.svg";
import { Button } from "antd";
import { ThemeContext } from "../../../Contexts/ThemeProvider";
import { IssuesCloseOutlined } from "@ant-design/icons";
import { verify } from "../../../API/auth";

const Verify = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  console.log(id);

  const sendLink = async () => {
    setLoading(true);
    try {
      const response = await verify(id);
      console.log(response.data);
      navigate("/login");
    } catch (error) {
      console.error("Failed to perform the necessary action", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reset-page">
      <div className="logo">
        <img src={isDarkMode ? logoDark : logo} alt="Company Logo" />
      </div>

      <div className="reset">
        <div className="reset-card">
          <Button
            type="text"
            icon={
              <img
                src={isDarkMode ? backDark : back}
                alt="Back"
                className="back-icon"
              />
            }
            onClick={() => navigate("/login")}
            className="back-button"
          >
            Back
          </Button>

          <div className="title">
            <div className="main">
              <IssuesCloseOutlined style={{ color: "green" }} /> Verify Your
              Email
            </div>
            <div className="sub">
              Please click the button below to verify your email
            </div>
          </div>

          <Button
            type="default"
            className="check-email-button"
            loading={loading}
            onClick={sendLink}
          >
            Verify Email Adrress
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Verify;
